import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AppGlobals {
  headers = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': '*'
  });
  defaultLanguage = 'en';
  defaultLocale = 'US';
  minPasswordLength = 6;
  profileImageTypes = ['png', 'jpg', 'jpeg']; //['png', 'jpg', 'jpeg', 'gif', 'tiff', 'bpg'];
  maxProfileImageSize = 5 * 1024 * 1024; //in bytes
  defaultProfileImage = 'assets/images/default-avatar.png';
  maxUserCSVSize = 10 * 1024 * 1024; //in bytes
  userCSVHeaders = ['username', 'email', 'first name', 'last name', 'course'];
  courseIconTypes = ['png', 'jpeg']; //['png', 'jpg', 'jpeg', 'gif', 'tiff', 'bpg'];
  maxCourseIconSize = 5 * 1024 * 1024; //in bytes
  gameIconTypes = ['png', 'jpeg']; //['png', 'jpg', 'jpeg', 'gif', 'tiff', 'bpg'];
  maxGameIconSize = 5 * 1024 * 1024; //in bytes
  regex = {
    email: new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ),
    // email: new RegExp(/^\w+([\.\-\+]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/),
    // username: new RegExp(/^(?=.{1,150}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/),
    username: new RegExp(/^[\w.@+-]+$/),
    number: new RegExp(/^(?=.*?[0-9])/),
    numberOnly: new RegExp(/^-?\d*\.?\d+$/),
    lowerCase: new RegExp(/^(?=[^a-z]*[a-z])/),
    upperCase: new RegExp(/^(?=[^A-Z]*[A-Z])/),
    symbol: new RegExp(/^(?=.*?[#?!@$%^&*-])/),
    length: (min?: number, max?: number) =>
      new RegExp('^.{' + (min ?? '') + ',' + (max ?? '') + '}$'),
    name: new RegExp(/^[a-z\s,\.'\-]+$/i),
    courseCode: new RegExp(/^[\d\w]+$/),
  };
  minAsyncSearchCharacter = 1;
  defaultDebounceTime = 200;
  bumpPeriodCountPerTrigger = 5;
  homePath = '/course/list';
}
